import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { getRest } from './api/getRest';
import { IRestProduct } from 'app/types/rest/IRestProduct';
import { productsSetAction } from 'app/store/model/actions/productsSetAction';

export const loadProducts = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(getRest()).then((list: IRestProduct[]) => {
            dispatch(productsSetAction(list));
        });
    };
    return action;
};
